export default {"src":"/_next/static/media/hero.ab2ba8b4.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};